import React from 'react';
import './CustomerOrders.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import Table from 'react-bootstrap/Table';
import {Form } from 'react-bootstrap'; // Ensure Form is imported
import Pagination from "react-js-pagination";
import { useLocation } from 'react-router-dom';
import profile from '../../images/splash/avatar.png';


const CustomerOrders = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`; // For date input compatibility
  };
  
  // Utility function to format the date to 'DD-MM-YYYY'
  const formatDateForAPI = (date) => {
    const [yyyy, mm, dd] = date.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };
  const location = useLocation();
  const history = useHistory();
  const [ show, setShow ]  = useState(false);
  const [ tables, setTables ] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [bookingOrder, setBookingorders] = useState([]);
  
  const [ orderedItems, setorderItems ] = useState([]);

  const [ shops, setShops ] = useState([]);
  const [ selectedShop, setSelectedShop ] = useState(null);
  const [ selectedItemCode, setSelectedItemCode ] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  const [ itempopup, setItempopup ] = useState(false);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  const [ orderNo, setOrderNo ] = useState('');
  
  const [ isCreate,setCreate ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const [selectedDate, setSelectedDate] = useState(''); // Default to current date

   // Parse the query parameters
   const queryParams = new URLSearchParams(location.search);
   const { customer_id, customer_name } = location.state || {};

  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});
const [expandedRow, setExpandedRow] = useState(null);

console.log(formData)

useEffect(() => {
  // const formattedDate = formatDateForAPI(selectedDate); // Format to 'DD-MM-YYYY'

  fetchTables(); // Initial fetch with the default date
}, []);
const handleDateChange = (event) => {
  const newDate = event.target.value; // Get the selected date in YYYY-MM-DD
  setSelectedDate(newDate); // Update state
  const formattedDate = formatDateForAPI(newDate); // Format to 'DD-MM-YYYY'
  fetchTables(formattedDate); // Call the API with the formatted date
};

  useEffect(() => {
    if (selectedDate === '') {
      fetchTables();
    }
  }, [selectedDate]);


const fetchTables = async (date = null) => {
  setLoading(true);
    const shop_id=localStorage.getItem('ShopId');
    const token=localStorage.getItem('Token');
  try {
    const url = date
      ? `${var_api}booking-orders/customer-order-list/${customer_id}/${shop_id}/${date}`
      : `${var_api}booking-orders/customer-order-list/${customer_id}/${shop_id}`;
    
    const response = await axios.get(url, {
      headers: {
        Authorization: `${token}` // Ensure correct token format
      }
    });

    setLoading(false);
    const user = response.data.data;
    setTables(user);
  } catch (error) {
    setLoading(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
    if (error.response) {
      console.error("Server response:", error.response);
    }
    setTables([]);
  }
};


      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};



  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
   


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //delete the employeee
    const handleDelete = () => {
      axios
      .delete(`${var_api}/api/employees/emp-delete/${EmployeeD.id}`)
      .then((response) => {
        if (response.status === 200) {
          fetchTables();
          setShow(false);
          Swal.fire("success"," Employee Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Table not found');
          Swal.fire("error","Employee not found!","error")
        }
      })
      .catch((error) => {
        console.error('Error executing the request:', error);
        Swal.fire("error","Failed to Remove Employee!","error")
        // Handle the error as needed
      });
    }


    //Function for open the update modal
    const handleUpdateEmployee = () =>{
      setIsEdit(true);
    //   console.log("data",data)
    //   setUpdateFormData({
    //       id:data.id,
    //       e_name: data.e_name, 
    //       e_email: data.e_email, 
    //       e_password: data.e_password,
    //       e_phone: data.e_phone,
    //       e_role: data.e_role,
    //       profile: data.e_profile,
    //       shops: data.shops
    //   })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};

const handleshow =(data, orderNo)=>{
  setBookingorders(data);
  setItempopup(true);
  setOrderNo(orderNo);
}

const handleshowItems =(data)=>{
  setorderItems(data);
  setOrderedItempopup(true);
}
 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};



  const getOrderStatusText = (status) => {
    switch(status) {
      case 0: return "New";
      case 1: return "In Progress";
      case 2: return "Packed";
      case 3: return "Delivered";
      case 4: return "Cancelled (by customer)";
      default: return "Unknown";
    }
  };
  
  // Function to get the payment status text based on the payment_status value
  const getPaymentStatusText = (status) => {
    return status === 1 ? "Paid" : "Not Paid";
  };
  
  // Function to get the slot type text based on the slot_type value
  const getSlotTypeText = (type) => {
    return type === 1 ? "Multi-slot" : "Single slot";
  };

  const [openRemark, setOpenRemark] = useState(false); // Modal state
  const [approvalStatus, setApprovalStatus] = useState(null); // Approval status (1 for accept, 2 for reject)
  const [selectedOrderId, setSelectedOrderId] = useState(null); // Track selected order ID
  const [remark, setRemark] = useState(""); // Remark input\
  const [selectedOrderNo, setselectedOrderNo] = useState(null); // Track selected order ID

  
  // Function to handle Accept action
  const handleAccept = async (orderId,orderNo) => {
    const payload = {
      approval_status: 1, // Approve
    };
    await sendApprovalPayload(orderId, payload,orderNo);
  };

  // Function to handle Reject action
  const handleReject = (orderId,orderNo) => {
    setSelectedOrderId(orderId); // Set the selected order ID
    setselectedOrderNo(orderNo); // Set the selected order ID

    setOpenRemark(true); // Open the modal
  };
  const getCurrentDates = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = today.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // Function to confirm the Reject action with a remark
  const confirmReject = async () => {
    const payload = {
      approval_status: 2, // Reject
      reject_remarks: remark, // Include the entered remark
      rejected_date: getCurrentDates()
    };
    
    await sendApprovalPayloadReject(selectedOrderId, payload);
    setOpenRemark(false); // Close the modal
    setRemark(""); // Clear the remark input
  };

  // Function to send the payload to the backend
  const sendApprovalPayload = async (orderId, payload,orderNo) => {
    try {
      const token=localStorage.getItem('Token');
      const response = await axios.put( `${var_api}booking-orders/update/${orderId}`,
        payload,{headers:{
          Authorization:`${token}`
        }
      }
      );
      console.log("Response:", response.data);
      fetchTables();
      Swal.fire({
        icon: "success",
        title: `<div style="font-size: 1.0em; font-weight: bold; color: #4caf50;">Order Accepted Successfully!</div>`,
        html: `<div style="font-size: 1.2em; color: #333;">
                 <p><strong>Order ID:</strong> <span style="color: #4caf50;">${orderNo}</span></p>
                 <p>The order is now moving to <strong>Active Orders</strong>.</p>
               </div>`,
        confirmButtonText: '<span style="font-size: 1em; font-weight: bold;">OK</span>',
        buttonsStyling: false,
        customClass: {
          confirmButton: "custom-swal-btn",
          popup: "custom-swal-popup",
        },
      });
      
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `${error.response.data.error}`,
        confirmButtonText: "OK",
      });    }
  };



  const sendApprovalPayloadReject = async (orderId, payload) => {
    try {
      const token=localStorage.getItem('Token');
      const response = await axios.put( `${var_api}booking-orders/update/${orderId}`,
        payload,{headers:{
          Authorization:`${token}`
        }
      }
      );
      console.log("Response:", response.data);
      fetchTables();
      Swal.fire({
        icon: "error", // Custom emoji for rejection
        title: `<div style="font-size: 1.0em; font-weight: bold; color: #e53935;">Order Rejected</div>`,
        html: `<div style="font-size: 1.2em; color: #333;">
                 <p><strong>Order ID:</strong> <span style="color: #e53935;">${selectedOrderNo}</span></p>
                 <p>The order has been <strong>rejected</strong> and will not proceed further.</p>
               </div>`,
        confirmButtonText: '<span style="font-size: 1em; font-weight: bold;">OK</span>',
        buttonsStyling: false,
        customClass: {
          confirmButton: "custom-swal-btn-rejected",
          popup: "custom-swal-popup-rejected",
        },
      });
      
      
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `${error.response.data.error}`,
        confirmButtonText: "OK",
      });    }
  };



  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Filtered orders based on search query
  const filteredOrders = tables.filter((order) => {
    const orderType = order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order"  : "-";
    const payment = order.payment_status === 1 ? "Paid"  : "Not Paid";
    const orderStatus = order.order_status === 0 ? "New" : order.order_status === 1 ? "Partial"  :order.order_status === 2 ? "Completed":order.order_status === 4 ? "Cancelled": "Cancelled";
    const approvalStatus = order.approval_status === 1 ? "Approved" : order.approval_status === 2 ? "cancelled"  : "New";

  return(
    order.customer_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  order.delivery_address.toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(order.order_no).toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(order.mobile_no).toLowerCase().includes(searchQuery.toLowerCase()) ||
  // order.slot_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(order.amount).toLowerCase().includes(searchQuery.toLowerCase()) ||
  order.paymode_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(order.order_date).toLowerCase().includes(searchQuery.toLowerCase()) ||
  orderType.toLowerCase().includes(searchQuery.toLowerCase()) ||
  payment.toLowerCase().includes(searchQuery.toLowerCase()) ||
  orderStatus.toLowerCase().includes(searchQuery.toLowerCase()) ||
  approvalStatus.toLowerCase().includes(searchQuery.toLowerCase()) ||
  String(order.order_time).toLowerCase().includes(searchQuery.toLowerCase())
);
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleBackClick = () => {
    // Navigate to the desired route, e.g., '/customers-list'
    history.push('/normal-customers');  // Replace with your actual route
  };

    return(
      <>         <Layout>
            <div class="splituo">
          
            <div style={{border:"none", padding:"15px", width:"103%", minHeight:"580px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"17px",float:"right",borderRadius:"10px"}}>Create Category</Button>{' '}
       */}
      <div>
    
     
       <div class="row">
         <div class="col">
         <h4 className='ushe'><i class="bi bi-arrow-left" onClick={handleBackClick}></i> {customer_name}'s ORDERS</h4>
         </div>
         <div class="col">

         </div>
         <div class="col">

</div>
         <div className="col" style={{maxWidth:"450px"}}>
         <div className="d-flex align-items-center" style={{ maxWidth: "250px" }}>
         <h6 style={{ marginRight: "10px", whiteSpace: "nowrap" }}>Delivery Date:</h6>
         <input
        type="date"
        className="form-control form-control-md"
        id="fromDate"
        name="fromDate"
        style={{ borderRadius: "5px", fontSize: "15px", float: "right" }}
        value={selectedDate} // Bind the value to the state in YYYY-MM-DD format
        onChange={handleDateChange} // Trigger API call on date change
      />
       </div>
        </div>
         <div class="col">
         <input
        type="text"
        placeholder="Search "
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{
          marginBottom: "20px",
          width: "100%",
          padding: "8px",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
      />
         </div>
        
       </div>
      <div className="table-container" style={{ height:"540px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
      <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Date
      </th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col"> Delivery Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Id</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Customer name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Type</th> */}
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Payment Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Paymode</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Approval Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Status</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Booking Dates
      </th> */}

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th> */}
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen" style={{fontSize:"14.5px"}}>
   {/* {filteredSuppliers && filteredSuppliers.length > 0 ? (
   filteredSuppliers && filteredSuppliers.map((data,index) =>( */}
 {currentOrders.length > 0 ? (
currentOrders.map((order, index) => (
   <React.Fragment key={index}>
        <tr  style={{ padding: "4px" }}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>{indexOfFirstItem+index+1}</th> 
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.order_date }</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.delivery_address}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left", color:"blue" }}>{order.order_no}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left", color: order.order_type === 1 ? "purple" : "orange", fontWeight: "bold" }}> {order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order"  : "Pending"}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.customer_name}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.mobile_no}</td>
            {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}> {getSlotTypeText(order.slot_type)}</td> */}
          {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.slot_name}</td> */}
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.amount}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}> {getPaymentStatusText(order.payment_status)}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{order.paymode_name}</td>
          <td
  style={{
    textTransform: "capitalize",
    textAlign: "left",
    color:
      order.approval_status === 0
        ? "blue"
        : order.approval_status === 1
        ? "green"
        : "red",
    fontWeight: "bold",
  }}
>
  {order.approval_status === 0
    ? "New"
    : order.approval_status === 1
    ? "Approved"
    : "Cancelled"}
</td>
<td style={{
          textAlign: "left",
          color: order.order_status === 0 ? "blue" :
                 order.order_status === 1 ? "orange" :
                 order.order_status === 2 ? "green" :
                 order.order_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {order.order_status === 0 ? "New" :
           order.order_status === 1 ? "Partial" :
           order.order_status === 2 ? "Delivered" :
           order.order_status === 4 ? "Cancelled" : "Cancelled"}
        </td>
          {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}>
             <button className="btn btn-primary" onClick={() => handleshow(order.booking_dates)}>
                                              <i style={{ color: "white", fontSize: "20px" }} className="bi bi-eye-fill"></i>
                                            </button></td> */}
        <td>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  <button
      className="btn btn-primary"
      onClick={() => handleshow(order.booking_dates, order.order_no)}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <i
        style={{ color: "white", fontSize: "13px" }}
        className="bi bi-eye-fill"
      ></i>
    </button>
  </div>
</td>


          {/* <td>
            <div style={{ textTransform: "capitalize", textAlign: "left", display: "flex", gap: "2px" }}>
              {order.actionButtons.map((buttonText, btnIndex) => (
                <Button key={btnIndex} variant={buttonText === "Pending" ? "warning" : "danger"}>{buttonText}</Button>
              ))}
            </div>
          </td> */}
        </tr>

        {/* {expandedRow === index && (
                <tr>
                  <td colSpan="15" style={{ padding: "0", backgroundColor: "#f9f9f9"}}>
                    <table className="table table-hover" style={{ width: "90%", margin:" 20px auto" }}>
                      <thead>
                        <tr>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.NO</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Item Image</th>

                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Item Code</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Item Name</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Quantity</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Unit Price</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Total Price</th>
                          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Remark</th>
                        </tr>
                      </thead>
                      <tbody class="body-half-screen" >
                        {order.order_items.map((item, idx) => (
                          <tr key={idx}>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{idx+1}</td>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                              <img   src={`${var_api}/${item.food_image}`} alt="item_iamge" width="30px" height="30px" />
                            </td>
                            
                                <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.item_code}</td>

                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.food_name}</td>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.quantity}</td>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.unit_price}</td>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.quantity * item.unit_price}</td>
                            <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.remark}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )} */}
        </React.Fragment>
      ))
    ) : (
      <tr>
        <td colSpan="14" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
          No Upcoming Orders Found
        </td>
      </tr>
    )}
 

   </tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={filteredOrders.length}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Category Name 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>


      <Modal
        show={openRemark}
        onHide={() => setOpenRemark(false)}
        backdrop="static"
        keyboard={false}
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Are You Sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="remarkTextarea">
            <Form.Label>Remark</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter your remark"
              value={remark}
              onChange={(e) => setRemark(e.target.value)} // Update remark state
            />
          </Form.Group>
          <Button
            variant="danger"
            className="mb-4"
            style={{
              fontSize: "14px",
              float: "right",
              borderRadius: "10px",
              marginLeft: "10px",
            }}
            onClick={confirmReject}
          >
            Confirm Reject
          </Button>
        </Modal.Body>
      </Modal>



      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates (Order No-{orderNo})</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Delivery Date</th>
          <th>Slot Name</th>
          <th>From Time</th>
          <th>To Time</th>
          <th>Delivery Person</th>
          <th>status</th>
          <th>View List</th>

        </tr>
      </thead>
      <tbody>
  {bookingOrder.length > 0 ? (
    bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{ borderBottom: "1px solid #ddd" }}>
            <td>{slotIndex + 1}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
 style={{
  textAlign: "center",
  display: "flex",
  borderTop: "none",
  borderBottom: "none",
  alignItems:'center',

  gap: "20px",
  alignContent: "center",
  // marginTop: "11px",
  height: "100px",
}}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
        <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "orange" :
          slot.slot_status === 2 ? "green" :
          slot.slot_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Inprogress" :
           slot.slot_status === 2 ? "Packed" :
           slot.slot_status === 3 ? "Delivered" : "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "20px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    )
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>
<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>

          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Remarks</th>


        </tr>
      </thead>
      <tbody>
      {orderedItems.length > 0 ? (

      orderedItems.map((item, index) => (
          <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
            <td>{index + 1}</td>
            <img
  src={`${image_api}/${item.food_image}`}
  alt="item_image"
  width="50px"
  height="50px"
/>


            <td>{item.food_name}</td>
            <td>{item.item_code}</td>
            <td>{item.quantity}</td>
            <td>{item.unit_price}</td>
            <td>{item.variant_name}</td>
            <td>{item.remark}</td>


          </tr>
          
        )))
        : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>
    

   


            {/* </div> */}
       </Layout></>

        
    )
}




export default CustomerOrders;